import { inject, InjectionToken } from '@angular/core';
import { ADID_COOKIE, ADID_QUERY_PARAM } from '../constants/adid.const';
import { resolveQueryCookieParam } from '../helpers/query-cookie-param/query-cookie-param.helper';
import { CookieFacade } from '../services/cookie/cookie.facade';
import { WINDOW } from './window';

/** Live resolver: call on each AGW request; do not treat inject result as a cached string. */
export type AdidResolver = () => string | null;

export const ADID: InjectionToken<AdidResolver> = new InjectionToken<AdidResolver>('Adid Token', {
  providedIn: 'root',
  factory: (): AdidResolver => {
    const window: Window = inject(WINDOW);
    const cookieFacade: CookieFacade = inject(CookieFacade);

    return (): string | null =>
      resolveQueryCookieParam({
        location: window.location,
        cookieFacade,
        queryParam: ADID_QUERY_PARAM,
        cookieName: ADID_COOKIE,
        hostname: window.location.hostname,
      });
  },
});
